define('webshopProductsFinderListHeaderToolsView',[
  'app',
  'module',
  'underscore',
  'orderUtils',
  'buttonView',
  'tableHeaderFieldView',
  'template!webshopProductsFinderListHeaderToolsView'
], function (
  App,
  Module,  
  _,
  OrderUtils,
  ButtonView,
  FieldView,
  Tpl
) {
  'use strict';

  Module.exports = FieldView.extend({
    template: Tpl,
    className: 'webshop-products-finder-list-header-tools-view ' + FieldView.prototype.className,

    regions: {
      selectRegion: '.select-region'
    },

    onRender: function() {
      this.listenTo(this.tableView.selectedProducts, 'change', _.bind(function() {
        this.renderSelectButton();
      }, this));

      this.selectButtonView = new ButtonView({
        type: 'select',
        color: 'orange',
        text: _.i18n('common.select'),
        title: _.i18n('common.select')
      });
      this.selectRegion.show(this.selectButtonView);
      this.selectButtonView.on('click', _.bind(this.onConfirm, this));
      this.selectButtonView.enabled(false);
    },

    renderSelectButton: function() {
      if(this.tableView.selectedProducts.get('products').length > 0)
        this.selectButtonView.enabled(true);
      else
        this.selectButtonView.enabled(false);
    },

    onConfirm: function() {
      this.tableView.onConfirm();
    }
  });
});
